// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"f119d1bf","453":"b1f2b162","591":"32875a13","680":"c53e1cec"}[chunkId] + ".chunk.js";
};